export function serviceWorker() {
    // Register a service worker hosted at the root of the site using the default scope.
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.register('/serviceWorker.js')
            .then(function(registration) {
                // Registration was successful
                console.log('ServiceWorker registration successful with scope: ', registration.scope);
            }).catch(function(error) {
            // registration failed
            console.log('ServiceWorker registration failed: ', error);
        });
    } else {
        // Fallback
        console.error('Service workers are not supported.');
    }
    return 'serviceWorker';
}